export default "__VITE_PUBLIC_ASSET__71ba252d__"